import { render, staticRenderFns } from "./VinTransferManagement.vue?vue&type=template&id=9c171f76"
import script from "./VinTransferManagement.vue?vue&type=script&lang=js"
export * from "./VinTransferManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports